import React from 'react';
import { NTooltip } from '@innersource-nn/novoui-react';
import clsx from 'clsx';
interface NTooltipProps {
    label?: string;
    content: string;
    disabled?: boolean;
    checkbox?: boolean;
}
export default function LabelTooltip({
    label,
    content,
    disabled,
    checkbox,
}: NTooltipProps) {
    return (
        <div
            className={clsx(
                disabled ? 'text-sand-grey-700' : 'text-true-blue',
                'text-sm flex items-center',
                !checkbox && 'mb-12',
            )}
        >
            {label && <span className="input-label">{label}</span>}
            <NTooltip
                content={content}
                indicator
                placement="up"
                className="ml-8"
                iconSize={12}
            />
        </div>
    );
}
